<template>
  <el-dialog title="用户个人资料" :visible.sync="visible" :append-to-body="true">
    <el-row class="card">
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <el-avatar
            :size="180"
            :src="user.avatar"
          />
        </div>
      </el-col>
      <el-col :span="12">

        <el-form :model="user" size="large ">
          <el-form-item label="用户ID：" :label-width="formLabelWidth">
            {{ user.id }}
          </el-form-item>
          <el-form-item label="用户名：" :label-width="formLabelWidth">
            {{ user.nickname }}
          </el-form-item>
          <el-form-item label="真实姓名：" :label-width="formLabelWidth">
            {{ user.truename }}
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-dialog>

</template>

<script>
// import { getUser } from '@/api/user'
export default {
  props: {
  },
  data() {
    return {
      visible: false,
      formLabelWidth: '220',
      user: {}
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async getUser() {
      // if (!this.uid) {
      //   return false
      // }
      // this.loading = true
      // const res = await getUser(this.uid)
      // this.user = res.data
      // this.loading = false
    }
  }

}
</script>
<style scoped lang="scss">
.bg-purple{
  height:200px;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
